export default "__VITE_ASSET__v1bG0bjk__"